/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedGpTaskListResponse } from '../types/PaginatedGpTaskList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type GpTasksListRequest = {} | null | undefined;
export type GpTasksListResponse = PaginatedGpTaskListResponse;

export type GpTasksListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/gp_tasks/
 *
 * ```yaml
 * operationId: gp_tasks_list
 * tags:
 *   - gp_tasks
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedGpTaskList'
 *     description: ''
 * ```
 */
export const gpTasksListOperation = (rest?: GpTasksListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/gp_tasks/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/gp_tasks/' };
  };

/**
 * GET /dmx-server/gp_tasks/
 *
 * ```yaml
 * operationId: gp_tasks_list
 * tags:
 *   - gp_tasks
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedGpTaskList'
 *     description: ''
 * ```
 */
export const gpTasksList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: GpTasksListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedGpTaskListResponse>> => {
  const operation = gpTasksListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/gp_tasks/
 */
export const useGpTasksListResource = (
  query: GpTasksListQuery | null,
  useCached?: boolean,
): UseResource<GpTasksListResponse> => {
  return useResource<GpTasksListResponse>({
    path: query === null ? null : gpTasksListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
